// extracted by mini-css-extract-plugin
module.exports = {"jds-CardFeedback":"cardFeedback_jds-CardFeedback__Lr8jw","jds-CardFeedback__Text":"cardFeedback_jds-CardFeedback__Text__aoaF2"};